<template lang="pug">

</template>

<script>

export default {
	props: {
		items: {
			type: Array,
			default: null
		},

		quickView: {
			type: Boolean,
			default: false
		}
	}
};
</script>